import { CanActivateFn } from '@angular/router';
import { effect, EffectRef, inject } from '@angular/core';
import { getRoutePath } from '../../shared/constants/route-path-mapping';
import { NavService } from '../services/nav.service';
import { commonLiterals } from '../../shared/constants/common-literals';
import { RoleService } from '../../features/user-management/services/role.service';
import { UserPermissionType } from '../../features/user-management/enums/user-permission-type.enum';

export const roleGuard: CanActivateFn = async (route, state) => {
  const roleService = inject(RoleService);
  const navService = inject(NavService);
  if (!roleService.moduleWiseUserPermissionsResource.isLoading() && !roleService.moduleWiseUserPermissionsResource.hasValue()) {
    roleService.moduleWiseUserPermissionsResource.reload();
  }
  // Wait until isLoading becomes false using a transient effect
  await new Promise<void>((resolve) => {
    const ref: EffectRef = effect(() => {
      if (!roleService.moduleWiseUserPermissionsResource.isLoading()) {
        ref.destroy();
        resolve();
      }
    }, { manualCleanup: true });
  });
  if (state.url === commonLiterals.rootPath) {
    /*
      Note: We're not checking permissions for the root path (/) since the landing component 
      immediately redirects to a route like /home or /settings/*, where this guard will validate access.
    */
    return true;
  }
  const permissions = roleService.moduleWiseUserPermissions();
  if (permissions.find((item) => {
    const paths = getRoutePath(item.module);
    return paths.find((path) => state.url.includes(path));
  })?.permission === UserPermissionType.Yes) {
    return true;
  }
  const childRoute = route.firstChild; // Access the first child route of the current route
  navService.navigateToPageState('unauthorized-access', { data: { name: childRoute?.data?.['name'] } }); // Access the `data` property defined in the child route configuration
  return false;
};
